import React from 'react';

export default function ContactMap() {
    return (
        <iframe
            className="contact-map minor-margin--top"
            frameBorder="0"
            src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJN7fqNX_L1IkR--D1zPfWzaw&key=AIzaSyAuwh7uwPXVIW9B6ZTYoi2oZdE6P9ub99o"
            allowFullScreen={true} />
    )
};
